// DS: DS6.1 - Radio button semantics
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import RadioButton from '../../../../RadioButton';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import s from './ListItemRadioButton.scss';
const ListItemRadioButton = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { rootProps: { name , value , onChange , checked , className  } , contentProps , ref  } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "name",
        "value",
        "onChange",
        "checked",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(RadioButton, _extends({
        ref: ref,
        className: c(s['root'], className),
        name: name || '',
        value: value || '',
        onChange: onChange && (()=>onChange(!checked, value)),
        checked: checked
    }, rest), /*#__PURE__*/ React.createElement(ListItemContent, _extends({}, contentProps)));
};
ListItemRadioButton.displayName = 'ListItemRadioButton';
export default ListItemRadioButton;
